// Pure variant matching shared by the purchase UI and regression checks.
const purchaseOptions = (() => {
  const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  function groups(game) {
    return game.options.map((option, index) => ({
      ...option,
      index: Number(option.position || index + 1) - 1,
      label: /consola/.test(normalize(option.name)) ? 'Consola' : /cuenta|cunta/.test(normalize(option.name)) ? 'Tipo de cuenta' : option.name
    })).sort((a, b) => Number(b.label === 'Consola') - Number(a.label === 'Consola'));
  }
  function find(game, values) {
    return game.variants.find(variant => variant.options.every((value, index) => value === values[index]));
  }
  function candidates(game, values, index, value) {
    const ordered = groups(game);
    const earlier = ordered.slice(0, ordered.findIndex(group => group.index === index));
    return game.variants.filter(variant => variant.options[index] === value && earlier.every(group => variant.options[group.index] === values[group.index]));
  }
  function available(game, values, index, value) {
    return candidates(game, values, index, value).some(variant => variant.available);
  }
  function choose(game, values, index, value) {
    const requested = values.slice();
    requested[index] = value;
    const exact = find(game, requested);
    if (exact?.available) return exact.options.slice();
    const possible = candidates(game, values, index, value);
    const match = possible.find(variant => variant.available) || possible[0];
    return match ? match.options.slice() : values.slice();
  }
  function quantity(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? Math.max(1, Math.min(99, Math.trunc(parsed))) : 1;
  }
  function quote(variant, count) {
    if (!variant) return { price: 0, total: 0, compareAt: 0, saving: 0 };
    const price = Number(variant.price);
    const compareAt = Number(variant.compareAtPrice) > price ? Number(variant.compareAtPrice) : 0;
    return { price, total: price * quantity(count), compareAt, saving: compareAt ? Math.round((1 - price / compareAt) * 100) : 0 };
  }
  function checkoutUrl(game, variant, count) {
    if (!variant?.available) return '';
    return new URL('/cart/' + variant.id + ':' + quantity(count), game.url).href;
  }
  function label(value) {
    if (/^ps[45]$/i.test(value)) return value.toUpperCase();
    if (/^secunfaria$/i.test(value)) return 'Secundaria';
    return value;
  }
  return { groups, find, available, choose, quantity, quote, checkoutUrl, label };
})();
